import React, { useEffect, useState } from 'react';

function ImageLightbox({ images, activeIndex, onClose, onNavigate }) {
  const activeImage = images[activeIndex];
  const [imageSrc, setImageSrc] = useState(activeImage?.src || '');

  useEffect(() => {
    setImageSrc(activeImage?.src || '');
  }, [activeImage?.src]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }

      if (images.length > 1 && event.key === 'ArrowRight') {
        onNavigate(1);
      }

      if (images.length > 1 && event.key === 'ArrowLeft') {
        onNavigate(-1);
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [images.length, onClose, onNavigate]);

  if (!activeImage) {
    return null;
  }

  return (
    <div
      className="lightbox-backdrop"
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
      role="presentation"
    >
      <div className="lightbox-panel">
        <button
          type="button"
          className="lightbox-close"
          onClick={onClose}
          aria-label="Close image viewer"
        >
          ×
        </button>

        {images.length > 1 && (
          <button
            type="button"
            className="lightbox-arrow lightbox-arrow-prev"
            onClick={() => onNavigate(-1)}
            aria-label="Previous image"
          >
            ‹
          </button>
        )}

        <img
          src={imageSrc}
          alt={activeImage.alt || activeImage.name || 'Entry image'}
          className="lightbox-image"
          onError={() => {
            if (activeImage.previewSrc && imageSrc !== activeImage.previewSrc) {
              setImageSrc(activeImage.previewSrc);
            }
          }}
        />

        {images.length > 1 && (
          <button
            type="button"
            className="lightbox-arrow lightbox-arrow-next"
            onClick={() => onNavigate(1)}
            aria-label="Next image"
          >
            ›
          </button>
        )}

        <div className="lightbox-caption">
          <strong>{activeImage.name || 'Image'}</strong>
          <span>{activeImage.alt || 'No alt text provided'}</span>
          {images.length > 1 && <span>{activeIndex + 1} / {images.length}</span>}
        </div>
      </div>
    </div>
  );
}

export default ImageLightbox;
